import { SiteUtilities, LocationUtilities, A11y } from './utils';
const init = () => {
  const $form = $('.contact-sales-form');
  const $submitButton = $('#contact-sales-submit');
  $submitButton.on('click', function (event) {
    event.preventDefault();
    if (!$(this).parents('form').valid()) {
      return false;
    }
    createSupportTicket($form);
  });
};
const createSupportTicket = ($form) => {
  LocationUtilities.onLocationReady(function (geoLocation, simpleGeoLocation) {
    const country = simpleGeoLocation.countryName || '';
    const successCardTitle = $('.success-card ').data('card-title');
    const firstName = $form.find('.first-name-form').val() || '';
    const lastName = $form.find('.last-name-form').val() || '';
    const email = $form.find('.email-form').val() || '';
    const phone = $form.find('.phone-form').val() || '';
    const company = $form.find('.company-form').val() || '';
    const $customDropdown = $form.find('.custom-dropdown-form');
    const $customTextbox = $form.find('.custom-textbox-form');
    const $contactButton = $form.find('.button');
    const protocolRegex = /http:\/\/|https:\/\//gi;
    const languageCodes = ['de', 'nl', 'fr', 'se', 'es', 'latam', 'br', 'ru', 'jp', 'ko', 'it', 'cn', 'th', 'vi', 'pl', 'hk', 'fi', 'dk', 'no', 'tr', 'en-ae', 'en-za', 'eu', 'ms', 'id'];
    let pageUrl = SiteUtilities.getCurrentLocation();
    pageUrl = pageUrl.replace(protocolRegex, '');
    const tags = (pageUrl.split('/')[1] && languageCodes.includes(pageUrl.split('/')[1])) ? [`Contact Sales-${pageUrl.split('/')[1]}`] : ['Contact Sales'];
    const description = {
      'E-mail': email,
      Company: company
    };
    // In default product id set to freshworks (23498)
    const productId = Number($form.data('product-id')) || 23498;
    // In default group id set to presales (106108)
    const groupId = Number($form.data('group-id')) || 106108;
    const fmListId = Number($form.data('fm-list-id'));

    $contactButton.addClass('button--loading').attr('disabled', 'disabled');

    if ($customDropdown.length > 0 || $customTextbox.length > 0) {
      $.merge($customDropdown, $customTextbox).each((index, element) => {
        description[$(element).data('backend-key')] = $(element).val();
      });
    }

    const sendFreshmarketerLead = (fmListId) => {
      if (fmListId) {
        const freshmarketerData = {
          freshmarketerObject: {
            first_name: firstName,
            last_name: lastName,
            email: email,
            phone: phone,
            company: company,
            country,
            custom_field: {
              cf_freshmarketer_list: fmListId
            }
          }
        };
        if ($customDropdown.length > 0) {
          $customDropdown.each((index, ele) => {
            if ($(ele).data('freshmarketer-key') && $(ele).find('option:selected').data('fm-val')) {
              freshmarketerData['freshmarketerObject']['custom_field'][`cf_${$(ele).data('freshmarketer-key')}`] = $(ele).find('option:selected').data('fm-val');
            }
          });
        }
        SiteUtilities.freshmarketerPost(freshmarketerData, false, $form);
      }
    };

    const formatDescription = (description) => {
      let formatedDescription = '<p>';
      for (const key in description) {
        formatedDescription += `${key}: ${description[key]} <br>`;
      }
      formatedDescription += '</p>';
      return formatedDescription;
    };

    const createTicketOptions = {
      name: `${firstName} ${lastName}`.trim(),
      email: email,
      phone: phone,
      subject: 'Contact sales',
      tags,
      group_id: groupId,
      description: formatDescription(description),
      product_id: productId
    };

    try {
      jQuery.ajax({
        data: JSON.stringify(createTicketOptions),
        method: 'POST',
        url: 'https://alfred.freshworks.com/v1/fd-create-ticket',
        contentType: 'application/json',
        dataType: 'json'
      }).done((response) => {
        if (response.statusCode === 200 || response.statusCode === 201) {
          jQuery('.contact-sales-form-wrapper').addClass('success-reveal');
          $form.animate({
            opacity: '0',
            height: '0px'
          }, 50);
          jQuery('.contact-sales-title h6').text(successCardTitle);
          A11y.hideWithNoFocus(jQuery('.contact-sales-form-wrapper form')).hide();
          A11y.addToFocus(jQuery('.contact-sales-form-wrapper .success-card'));
        } else {
          $contactButton.removeClass('button--loading').val('Retry').removeAttr('disabled');
        }
      });
    } catch (e) {
      SiteUtilities.log(
        'SiteUtilites - Error: Failed to create freshdesk ticket',
        'error',
        'FW.SiteUtilites.createSupportTicket',
        2,
        e
      );
    }

    sendFreshmarketerLead(fmListId);
  });
};

export default { createSupportTicket, init };
